import { colors } from "shared/theme/color";

// The approved print-first PDF design (see the export design doc): charts
// keep the real Spott series colors; everything else stays on the ink
// ladder plus navy accents dark enough to survive black-and-white printing.
export const pdfTheme = {
  ink: colors.ink,
  ink2: colors.ink2,
  ink3: colors.ink3,
  ink4: colors.ink4,
  navy: colors.navy,
  amber: colors.amber,
  rule: colors.ink,
  hairline: "#DADADA",
  grid: "#E8E8E7",
};

// A4 in pt with the approved margins.
export const PAGE = {
  paddingTop: 40,
  paddingHorizontal: 44,
  paddingBottom: 56,
};

export const formatShortIdr = (value: number) => {
  if (value === 0) return "0";
  return `${(value / 1_000_000).toLocaleString("id-ID", { maximumFractionDigits: 1 })} jt`;
};

// 1 / 2 / 2.5 / 5 × 10^n ceiling for chart axes. Correct for MONEY axes only.
export const niceMax = (max: number) => {
  if (max <= 0) return 1;
  const power = Math.pow(10, Math.floor(Math.log10(max)));
  for (const step of [1, 2, 2.5, 5, 10]) {
    if (max <= step * power) return step * power;
  }
  return 10 * power;
};

// Integer ticks for a COUNT axis (people, sessions). niceMax is wrong for
// these: its ladder includes 2.5, and the fixed [0, max/2, max] label trio
// halves it again, so a max of 5 clients printed "0 / 2.5 / 5" — two and a
// half people. Mirrors countTicks in pages/analytics/chartUtils.ts, which
// the on-screen charts already use; kept as a copy so the lazy PDF chunk
// stays self-contained. `top` is the value to scale bars against.
const COUNT_STEPS = [1, 2, 5, 10, 20, 25, 50, 100, 200, 250, 500, 1000];
export const countTicks = (dataMax: number) => {
  const m = Math.max(1, Math.ceil(dataMax));
  // At most 4 intervals, so a small count keeps a readable ladder.
  const step = COUNT_STEPS.find((s) => m / s <= 4) ?? Math.ceil(m / 4);
  const top = Math.ceil(m / step) * step;
  const ticks: number[] = [];
  for (let v = 0; v <= top; v += step) ticks.push(v);
  return { top, ticks };
};
